import React from "react";
import { useDispatch } from "react-redux";
import { ReplaceTextToSpecialChar } from "../../../Helper/WidgetDataCommon";
import { layoutActions } from "../../../store/layout-slice";
import SearchableSelect from "../Controls/SearchableSelect";

const FilterControl = (props) => {

  const options = props.dtList.map((item, index) => {
    return {
      value: ReplaceTextToSpecialChar(item.filterName), label: ReplaceTextToSpecialChar(item.filterName),

    }
  });

  let finalOptions = [{ value: '', label: "Please Select", isDisabled: true },
  { value: 'None', label: "None" }, ...options, {
    value: "Divider",
    label: "-----------------------------------------", isDisabled: true
  },
  { value: "CreateNewFilter", label: "Create New Filter" },
  { value: "CloneFilter", label: "Clone Filter" },
  { value: "EditExistingFilter", label: "Edit / Delete Filter", isDisabled: props.dtList.length === 0 ? true : false }];

  if (props.dtList.length === 0) {
    finalOptions = finalOptions.filter(item => item.value !== "EditExistingFilter");
  }

  const dispatch = useDispatch();

  const onChangeHandler = (e) => {
    const value = e === "None" ? "null" : e;
    console.log("FilterControl onChangeHandler", e);
    if (value === "CreateNewFilter") {
      dispatch(layoutActions.setFilterPopup({ edit: false, clone: false }));
    }

    if (value === "EditExistingFilter") {
      dispatch(layoutActions.setFilterPopup({ edit: true, clone: false }));
    }

    if (value === "CloneFilter") {
      dispatch(layoutActions.setFilterPopup({ edit: false, clone: true }));
    }

    if (props.onChange !== undefined) {

      // const issharedfilter = e.target[e.target.selectedIndex].getAttribute(
      //   "data-issharedfilter"
      // );
      // const filterid =
      //         e.target[e.target.selectedIndex].getAttribute("data-filterid");
      // const originaluserid = e.target[e.target.selectedIndex].getAttribute(
      //         "data-originaluserid"
      //       );

      const getCurrentSelection = props.dtList.find(item => item.filterName === value);
      console.log("issharedfilter", getCurrentSelection);

      const issharedfilter = getCurrentSelection ? getCurrentSelection.isSharedFilter : false;
      const filterid = getCurrentSelection ? getCurrentSelection.filterId : null;
      const originaluserid = getCurrentSelection ? getCurrentSelection.originalUserId : null;

      const filterValueName = value //e.target.value;
      props.onChange({
        issharedfilter: issharedfilter,
        filterid: filterid,
        originaluserid: originaluserid,
        filterValue: filterValueName,
      });
    }
  };

  return (
    <div id="filterDiv">
      <p>Filter</p>
      <SearchableSelect
        onChangeHandler={onChangeHandler}
        optionList={finalOptions}
        value={props.value === 'null' ? 'None' : props.value} />
      {/* <select
        value-key="Filter"
        id="filterDdl"
        value={ReplaceTextToSpecialChar(props.value)}
        onChange={onChangeHandler}
      >
        <option value="0" disabled="disabled">
          Select Filter
        </option>
        {props.dtList.map((item) => {
          return (
            <option
              key={item.filterId}
              data-issharedfilter={item.isSharedFilter}
              data-filterid={item.filterId}
              data-originaluserid={item.originalUserId}
              value={ReplaceTextToSpecialChar(item.filterName)}
            >
              {ReplaceTextToSpecialChar(item.displayName)}
            </option>
          );
        })}
        <option value="null">None</option>
        <option disabled="disabled" value="Divider">
          -----------------------------------------
        </option>
        <option value="CreateNewFilter">Create New Filter</option>
        <option value="CloneFilter">Clone Filter</option>
        {props.dtList.length > 0 && (
          <option value="EditExistingFilter">Edit / Delete Filter</option>
        )}
        {props.dtList.length === 0 && (
          <option disabled="disabled" value="EditExistingFilter">
            Edit / Delete Filter
          </option>
        )}
      </select>
      <input type="hidden" value-key="IsSharedFilter" id="hdn_IsSharedFilter" />
      <input type="hidden" value-key="OriginalUserId" id="hdn_OriginalUserId" />
      <input type="hidden" value-key="FilterId" id="hdn_FilterId" /> */}
      <span style={{ display: "none", color: "red", paddingLeft: "5px" }}>
        Please select filter name
      </span>
    </div>
  );
};

export default FilterControl;
